import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit, inject, input } from '@angular/core';
import { Match } from '../../_shared/models/match.model';
import { FormControl, FormGroup } from '@angular/forms';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { ScoreboardService } from '../scoreboard.service';

@Component({
  standalone: false,
  selector: 'app-additional-player-info',
  templateUrl: './additional-player-info.component.html',
  styleUrls: ['./additional-player-info.component.scss'],
})
export class AdditionalPlayerInfoComponent implements OnInit {
  private modalController = inject(ModalController);
  private bhs = inject(BoardHelpService);
  private scoreboardService = inject(ScoreboardService);

  @Input({ required: true }) match: Match;

  form: FormGroup;

  ngOnInit(): void {
    this.form = new FormGroup({
      side1Note: new FormControl(this.match.sides[0].note),
      side2Note: new FormControl(this.match.sides[1].note)
    })
  }

  update() {
    this.scoreboardService
      .updatePlayerInformation(this.match._id, this.form.get('side1Note').value, this.form.get('side2Note').value)
      .pipe()
      .subscribe(
        res => {
          this.match.sides[0].note = this.form.get('side1Note').value;
          this.match.sides[1].note = this.form.get('side2Note').value;
          this.close();
        }
      )
  }

  getPlayerNames(sideNumber: number): string {
    let playerNames = this.bhs.getPlayersNames(this.match, sideNumber);

    return playerNames;
  }

  close() {
    this.modalController.dismiss();
  }
}
